import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const fetchWarehouseBalanceDetails = ({
  companyId,
  globalOutletId,
  warehouseIds,
}) => {
  return [
    {
      balance: 345.5,
      creditDays: 120,
      creditLimit: 10000.0,
      forOutletId: '23',
      id: '234',
      minordamount: 2345.56,
      outletId: '123',
      outletName: 'Some Outlet Name',
      warehouseId: '1',
      warehouseName: 'Cloud Dealers Pvt Ltd',
    },
    {
      balance: 525.0,
      creditDays: 120,
      creditLimit: 10000.0,
      forOutletId: '23',
      id: '235',
      minordamount: 2345.56,
      outletId: '123',
      outletName: 'Test Outlet Name',
      warehouseId: '2',
      warehouseName: 'Venkateshwara Sellers',
    },
    {
      balance: 1020.0,
      creditDays: 120,
      creditLimit: 10000.0,
      forOutletId: '23',
      id: '236',
      minordamount: 2345.56,
      outletId: '123',
      outletName: 'Test Outlet Name',
      warehouseId: '3',
      warehouseName: 'Sellers Two',
    },
  ];
};

const mocks = {
  Query: {
    warehouseBalanceDetails: (_, { companyId, globalOutletId, warehouseIds }) =>
      fetchWarehouseBalanceDetails({ companyId, globalOutletId, warehouseIds }),
  },
};

export { resolvers, typeResolvers, mocks };
